import { Swiper } from 'swiper';
import { A11y, Navigation, EffectFade, Pagination } from 'swiper/modules';

const contentSideImageCycleSliders = document.querySelectorAll(
	'.block-content-side-image-cycle__images'
);

if (contentSideImageCycleSliders.length) {
	const initSwiper = (slider) => {
		const settings = {
			loop: true,
			grabCursor: true,
			spaceBetween: 0,
			slidesPerView: 1,
			modules: [A11y, Navigation, EffectFade, Pagination],
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.querySelector('.swiper-button-prev'),
				nextEl: slider.querySelector('.swiper-button-next'),
			},
			pagination: {
				el: slider.querySelector('.swiper-pagination'),
				type: 'bullets',
			},
		};

		new Swiper(slider, settings);
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initSwiper(entry.target);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	contentSideImageCycleSliders.forEach((slider) => observer.observe(slider));
}
